import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { FormattedMessage } from 'react-intl';

class TagError extends Component {
  constructor (props) {
    super(props);
  }

  componentDidMount () {
    this.debouncer = debounce(() => {
      analyticsIntegrations.trackEvent('no space type tag options', {
        type_tag: this.props.type_tag,
        space_id: this.props.spaceId
      });
    }, 500);
    this.debouncer();
  }

  componentWillUnmount () {
    if (_.isFunction(this.debouncer)) {
      this.debouncer.cancel();
      this.debouncer = null;
    }
  }

  render () {
    return (
      <div>
        <FormattedMessage
          id="hosting.tag_error.error_message"
          defaultMessage="We couldn’t find that. Please try another type."
        />
      </div>
    );
  }
}

TagError.propType = {
  type_tag: PropTypes.string,
  spaceId: PropTypes.string
};

export default TagError;
